import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { dollars } from 'utils/money';
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider';

import { fetchOrganisations } from 'actions/organisations';
import Form from 'components/Organisations/Form';

const styles = theme => ({
  headerButton: {
    float: 'right'
  },
  flex: {
    flex: 1
  }
});

class List extends React.Component {
  componentWillMount = () => {
    this.props.dispatch(fetchOrganisations());
  };

  renderOrganisation = (organisation) => {
    return (
      <TableRow key={organisation.id}>
        <TableCell>
          <Link to={`/organisations/${organisation.id}`}>
            {organisation.name}
          </Link>
        </TableCell>
        <TableCell>
          {organisation.numberOfLoans}
        </TableCell>
        <TableCell>
          {dollars(organisation.totalPrincipal)}
        </TableCell>
        <TableCell>
          {dollars(organisation.totalInterest)}
        </TableCell>
        <TableCell>
          {organisation.organisationType}
        </TableCell>
        <TableCell>
          {organisation.abn}
        </TableCell>
        <TableCell>
          {organisation.email}
        </TableCell>
        <TableCell>
          {organisation.phone}
        </TableCell>
      </TableRow>
    );
  }

  render = () => {
    const { organisations, classes } = this.props;

    return (
      <div>
        <div style={{ display: 'flex' }}>
          <Typography variant='headline' className={classes.flex}>
            Organisations
          </Typography>
          <Form
            buttonStyles={classes.headerButton}
            buttonLabel='Add Organisation'
            mode='create'
          />
        </div>
        <Divider light />
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Loans</TableCell>
              <TableCell>Total Principal</TableCell>
              <TableCell>Total Interest</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>ABN</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Phone</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            { Object.values(organisations).map(this.renderOrganisation) }
          </TableBody>
        </Table>
      </div>
    );
  };
}

const mapStateToProps = (state) => {
  const { organisations } = state;
  return { organisations };
};

const styled = withStyles(styles)(List)
const connected = connect(mapStateToProps)(styled);
export default connected;



// WEBPACK FOOTER //
// ./src/components/Organisations/List.js